import React from "react";
import { Image, VStack } from "@chakra-ui/react";

import { IChildrenProp } from "types/IChildrenProp";

import warning from "assets/warning.svg";

import { NotificationPrototype } from "./components/NotificationPrototype";

interface IProps extends IChildrenProp {}

const WarningNotification = ({ children }: IProps) => {
  return (
    <NotificationPrototype>
      <VStack spacing={6}>
        <Image maxH="400px" src={warning} alt="Ostrzeżenie" />
        {children}
      </VStack>
    </NotificationPrototype>
  );
};

export { WarningNotification };
